<template>
  <div>
    <ASearchForm
      :loading="loading"
      :modelName="'Cart'"
      :search="false"
      :dropdownProps="[{model:'contracts', name: 'Contract', payloadKey: 'contractId', notClearable: true}
      ,{type:'text',name: 'Cart ID (contains)', payloadKey: 'name'}
      ,{model:'locations', name: 'Location', payloadKey: 'locationId'}
      ,{model:'states', name: 'Status', payloadKey: 'stateId'}
      ,{type:'text',name: 'Car #', payloadKey: 'car'}
      ,{type:'text',name: 'Missing Part', payloadKey: 'partId[]'}
     , {model:'workcenters', name: 'Work Center', payloadKey: 'workCenterId'}
      , {model:'stations', name: 'Station', payloadKey: 'stationId'}
       ]"
      :expandable="false"
      :hideSearchBtn="true"
      @change="search"
      ref="ASearchForm"
      class="mb-4"
    ></ASearchForm>
    <ATicker
      class="d-none"
      interval="5"
      :checked="true"
      label="Auto Refresh"
      showIntervalTime="true"
      @tick="onTick"
    ></ATicker>

    <div class="white">
      <div class="pl-2 pr-2 grey lighten-4">
        <v-row align="center" justify="space-around">
          <v-col class="text-left d-none d-md-flex">
            <v-btn-toggle v-model="viewMode" mandatory>
              <v-btn small>
                <v-icon>view_module</v-icon>
              </v-btn>
              <v-btn small>
                <v-icon>view_headline</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-col>
          <v-col class="text-right">
            <span class="blue-grey lighten-5 pa-2">
              <span class="font-weight-bold body-2">LEGEND :</span>
              <span class="box-body text-center empty pa-1 ma-1">EMPTY</span>
              <span class="box-body text-center full pa-1 ma-1">FULL</span>
              <span class="box-body text-center partial pa-1 ma-1">PARTIAL</span>
            </span>
          </v-col>
        </v-row>
      </div>
      <div style="height:2px">
        <v-progress-linear v-if="loading" color="primary" indeterminate height="2"></v-progress-linear>
      </div>
      <div
        ref="HeightAdjusterTarget"
        style="overflow-Y:scroll"
        :style="{height:heightToFill + 'px'}"
      >
        <div class="centered" v-if="(!items || items.length == 0) && !loading" color="primary">
          <div>
            <v-btn disabled>No Data</v-btn>
          </div>
        </div>
        <div class="pa-0">
          <v-row class="pa-0 ma-0">
            <template v-for="(location,locationName) in locations">
              <v-col sm="12" :key="locationName" :class="{'col-md-6':viewMode == 0?true:false}">
                <div style="top:-18px;position:relative;height:100%">
                  <div class="text-center" style="bottom:-18px;position:relative;">
                    <span
                      class="grey lighten-2 pa-1 pl-3 pr-3 body-2 font-weight-bold"
                    >{{locationName}}</span>
                  </div>
                  <div class="box text-center">
                    <div style="display: flex;flex-direction: row">
                      <template v-for="(station,stationName) in location">
                        <div class="column" style="min-width:120px;" :key="stationName">
                          <div class="box-header">{{stationName}}</div>
                          <div
                            class="box-body box-body-select"
                            :class="{full: cart.stateName == 'Full',empty: cart.stateName == 'Empty',partial: cart.stateName == 'Partial'}"
                            v-for="cart in station"
                            :key="cart.id"
                            @click="openCart(cart.id)"
                          >{{cart.shortString.length > 0? ( (cart.car.length >0? cart.car + "-":"") +cart.shortString) : cart.cartSpecialId}}</div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </v-col>
            </template>
          </v-row>
        </div>
      </div>
    </div>
    <CartModal ref="cartModal"></CartModal>
  </div>
</template>

<script>
import HeightAdjuster from "../../mixins/HeightAdjuster";
import ASearchForm from "../../components/ASearchForm";
import ATicker from "../../components/ATicker";
import CartModal from "../../components/CartModal";
import axios from "../../api/axios";

export default {
  mixins: [HeightAdjuster],
  components: {
    ASearchForm,
    ATicker,
    CartModal
  },
  data() {
    return {
      heightToReduce: 60,
      viewMode: 0,
      loading: false,
      model: "carts",
      apiParams: {},
      items: []
    };
  },
  computed: {
    locations: function() {
      let locations = {};
      this.items.forEach(e => {
        if (!locations[e.locationName]) {
          locations[e.locationName] = {};
        }
        if (!locations[e.locationName][e.stationName]) {
          locations[e.locationName][e.stationName] = [];
        }
        locations[e.locationName][e.stationName].push(e);
      });
      return locations;
    }
  },
  updated() {
    this.calculateTableHeight();
  },
  methods: {
    load: function() {
      this.loading = true;
      axios.get("/stats/locations-view", { params: this.apiParams }).then(r => {
        this.loading = false;
        if (r.data.ok) {
          this.items = r.data.d.items;
        }
      });
    },
    search(payload) {
      this.apiParams = payload;
    },
    onTick() {
      this.load();
    },
    openCart(cartId) {
      this.$refs.cartModal.open(cartId);
    }
  },
  watch: {
    apiParams: function() {
      this.load();
    }
  }
};
</script>

<style scoped>
.box {
  padding: 2px;
  margin-top: 5px;
  padding-top: 15px;
  display: inline-block;
  font-size: 14px;
  width: 100%;
  border: 1px solid #eeeeee;
  background-color: #f5f5f5;
  overflow-x: scroll;
  max-height: 700px;
  height: 100%;
}
.column {
  width: 150px;
  margin: 0px 6px;
}
.box-header {
  padding: 2px 4px;
  margin: 6px 0px;
  overflow-wrap: break-word;
  color: tomato;
  font-weight: bold;
  background-color: antiquewhite;
}
.box-body {
  border: 1px solid #e0e0e0;
  padding: 2px 4px;
  margin: 3px 0;
  overflow-wrap: break-word;
  font-size: 13px;
  cursor: pointer;
}
.box-body-select:hover {
  border: 1px red dashed;
}
.empty {
  background-color: white;
}
.full {
  background-color: #a5d6a7;
}
.partial {
  background-color: #fff9c4;
}
</style>


